import { render, staticRenderFns } from "./NewsItemList.vue?vue&type=template&id=f19889a8&lang=pug&"
import script from "./NewsItemList.vue?vue&type=script&lang=js&"
export * from "./NewsItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports